// extracted by mini-css-extract-plugin
module.exports = {"deleteStoryboard":"delete_deleteStoryboard__w0DhX","close":"delete_close__3GCVz","header":"delete_header__Y5thb","actions":"delete_actions__3aExP"};